import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import formatTime from "@/utils/format-time";


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayer',
  props: {
    videoUrl: null,
    startTime: null,
    endTime: null,
    aspectRatio: null,
    muted: { type: Boolean, default: true }
  },
  emits: ["loaded", "play", "stop", "timeupdate", "remove-video"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "loaded", element: HTMLVideoElement): void;
  (e: "play"): void;
  (e: "stop"): void;
  (e: "timeupdate", progress: number): void;
  (e: "remove-video"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { videoUrl: string, startTime: number, endTime: number, aspectRatio?: string, muted: boolean }





const paused = ref(true);
const videoWidth = ref(0);
const videoHeight = ref(0);

const togglePlayback = () => {
  paused.value ? emits("play") : emits("stop");
};

const duration = computed(() => {
  return props.endTime - props.startTime;
});

const onVideoTimeupdate = ({ target }: Event) => {
  if (target instanceof HTMLVideoElement) {
    if (target.currentTime > props.endTime || target.currentTime < props.startTime) {
      emits("stop");
    } else {
      emits("timeupdate", target.currentTime);
    }
  }
};

const onVideoLoadedMetadata = ({ target }: Event) => {
  if (target instanceof HTMLVideoElement) {
    emits("loaded", target);

    videoWidth.value = target.videoWidth;
    videoHeight.value = target.videoHeight;
  }
};

const onVideoPause = () => {
  paused.value = true;
};

const onVideoPlay = () => {
  paused.value = false;
};

const computedAspectRatio = computed(() => {
  return props.aspectRatio?.split(":").join(" / ") ?? videoWidth.value / videoHeight.value;
});

return { __sfc: true,props, emits, paused, videoWidth, videoHeight, togglePlayback, duration, onVideoTimeupdate, onVideoLoadedMetadata, onVideoPause, onVideoPlay, computedAspectRatio, formatTime }
}

})